import { LOCAL_STORAGE_NAME } from 'js/constants/App';

import { createLogger } from 'redux-logger';
import thunkMiddleware from 'redux-thunk';
import { applyMiddleware, legacy_createStore } from 'redux';
import RootReducer from './RootReducer';
import reduxfreezeMiddleware from 'redux-freeze';
import { composeWithDevTools } from '@redux-devtools/extension';

// https://github.com/rt2zz/redux-persist
import { persistReducer, createMigrate } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

const ConfigureStore = () => {
  const middlewares = [thunkMiddleware];
  if (process.env.NODE_ENV !== 'production') {
    middlewares.push(
      createLogger({
        collapsed: true,
        duration: true,
        timestamp: true,
      })
    );
  }
  if (JW_WATCH) {
    middlewares.unshift(reduxfreezeMiddleware);
  }

  // Migration to edit state
  // Create a new migration, apply changes to state in the function and bump the version number below
  const migrations = {
    0: (state) => {
      return {
        ...state,
      };
    },
    1: (state) => {
      // Add favoriteCuratedCollections array to user state
      return {
        ...state,
        user: {
          ...state.user,
          favoriteCuratedCollections: [],
        },
      };
    },
    2: (state) => {
      // clear out favoriteCuratedCollections on migration to remove any collections that may have been favorited that no longer exist
      return {
        ...state,
        user: {
          ...state.user,
          favoriteCuratedCollections: [],
        },
      };
    },
    3: (state) => {
      // clear out user collectionIds
      return {
        ...state,
        user: {
          ...state.user,
          collectionIds: [],
        },
      };
    },
  };

  const persistConfig = {
    key: LOCAL_STORAGE_NAME,
    storage,
    whitelist: ['user'], // whitelist of store keys to persist in localstorage
    version: 3,
    migrate: createMigrate(migrations, { debug: true }),
  };

  const persistedReducer = persistReducer(persistConfig, RootReducer);

  const store = legacy_createStore(persistedReducer, composeWithDevTools(applyMiddleware(...middlewares)));
  // const persistor = persistStore(store);

  // if (import.meta.hot) {
  //   import.meta.hot.accept((newModule) => {
  //     if (newModule) {
  //       // newModule is undefined when SyntaxError happened
  //       const nextRootReducer = require('./RootReducer').default;
  //       store.replaceReducer(nextRootReducer);
  //     }
  //   });
  // }
  // return { store, persistor };
  return store;
};

export default ConfigureStore();
